/* eslint-disable @typescript-eslint/no-namespace */
import { DealVersion } from '../../types/deal.types';
import { MapperHelpers } from '../mappers';
import { getObligor } from '../../utils/issuer-summary';

export namespace DealsObligors {
  export function getObligorNames(deals: DealVersion[]) {
    return MapperHelpers.getUniqSortedItemPropertiesFromArray(deals, {
      getProperty: (deal: DealVersion) => [deal],
      getArrayProperty: (dealList: DealVersion[]) =>
        dealList.map((deal) => getObligor(deal)).filter((name) => !!name),
      uniqBy: (name: string) => name,
      sortBy: (name: string) => name
    });
  }
}